module.exports = __webpack_public_path__ + "img/contact_text_bg.a2f5070b.png";